// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1uvk2","col":"styles_col__29p6F"};